<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <b-field horizontal name="sequence" :label="$t('attributes.sort')">
              <b-select v-model="form.sequence" name="sequence">
                <option
                  v-for="option in sequence_range"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </b-field>

            <b-field
              horizontal
              name="title"
              attribute="attributes.question"
              :label="$t('attributes.question')"
            >
              <b-input
                v-model="form.title"
                name="title"
                :placeholder="
                  $t('message.please_input') + $t('attributes.question')
                "
                expanded
              >
              </b-input>
            </b-field>

            <b-field horizontal name="note" :label="$t('attributes.note')">
              <b-input
                v-model="form.note"
                name="note"
                :placeholder="
                  $t('message.please_input') + $t('attributes.note')
                "
                expanded
              >
              </b-input>
            </b-field>
          </form-wrapper>
        </section>
        <footer class="modal-card-foot">
          <b-button class="is-fullwidth" @click="$parent.close()">
            {{ $t('attributes.cancel') }}
          </b-button>
          <b-button
            :loading="sending"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ question.id ? $t('attributes.update') : $t('attributes.add') }}
          </b-button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'SpotQuestionForm',

  props: {
    question: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sequence_range: [...Array(50).keys()].map(i => i + 1),

      sending: false,
      form: this.extractFormValues(this.question),
      options: this.question.options || []
    }
  },
  validations: {
    form: {
      sequence: {},
      title: { required, maxLength: maxLength(50) },
      note: { maxLength: maxLength(50) }
    }
  },
  computed: {
    formTitle() {
      return (
        this.$t(this.question.id ? 'attributes.modify' : 'attributes.add') +
        this.$t('attributes.spot_question')
      )
    }
  },
  watch: {
    question(newQuestion) {
      this.form = this.extractFormValues(newQuestion)
      this.options = newQuestion.options || []
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        id: data.id,
        sequence: data.sequence || 10,
        title: data.title || '',
        note: data.note || ''
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
